import { updateSubscription } from 'app/shared/flux/actions/MarketingActions';
import { augmentError, formatForLog } from 'app/shared/utils/errors';
import constants from 'app/shared/flux/constants';
import type { MarketUpdateStatusErrorType, MarketUpdateStatusType } from 'app/shared/types/ApiResponseTypes';

const logger = getLogger('pages/UnsubscribePage#serverRouteWillMount');

// @ts-ignore
const serverRouteWillMount = ({ store }) => {
  const { dispatch } = store;
  const { query, queryString, pathname } = store.getState().router.location;
  const { email, marketUpdateId, enabled = false } = query;
  return (
    dispatch(updateSubscription({ email: decodeURIComponent(email), enabled, marketUpdateId }))
      // @ts-ignore
      .then((res: MarketUpdateStatusType) => {
        const { marketUpdateEnabled, streetAddress } = res;
        const { street, state, city, zip, unit, hasUnitLabel } = streetAddress;
        const formattedAddress: string = `${street} ${hasUnitLabel ? unit : ''}, ${city}, ${state} ${zip}`;
        dispatch({
          type: constants.SET_UNSUBSCRIBE_RESULT,
          payload: { success: true, address: formattedAddress, isSubscribed: marketUpdateEnabled },
        });
        return;
      })
      .catch((err: MarketUpdateStatusErrorType) => {
        augmentError(err, {
          root: 'pages/UnsubscribePage#useEffect',
          pathAttempted: pathname,
          queryAttempted: queryString,
        });
        logger.error(formatForLog(err), 'Unsubscribe page: Error updating subscription');
        dispatch({
          type: constants.SET_UNSUBSCRIBE_RESULT,
          payload: { success: false },
        });
      })
  );
};

export default serverRouteWillMount;
